// src/components/HowItWorks.js
import React from "react";
import { FaRegHospital, FaRegComments, FaRegCalendarAlt } from "react-icons/fa";
import './HowItWorks.css';

const HowItWorks = () => {
    return (
        <section className="describe-section">
            <div className="describe-container">
                <h5 className="describe-subheading">Your Path to Wellness, Only a Click Away</h5>
                <h2 className="describe-main-heading">How It Works</h2>

                <div className="describe-columns">
                    <div className="describe-column">
                        <FaRegHospital className="describe-icon" />
                        <h3 className="describe-column-heading">Find a doctor</h3>
                        <p>Quickly search and browse qualified healthcare professionals.</p>
                    </div>

                    <div className="describe-column">
                        <FaRegComments className="describe-icon" />
                        <h3 className="describe-column-heading">Read reviews</h3>
                        <p>Read honest reviews from verified patients to help you make informed decisions.</p>
                    </div>

                    <div className="describe-column">
                        <FaRegCalendarAlt className="describe-icon" />
                        <h3 className="describe-column-heading">Book an appointment</h3>
                        <p>Effortlessly book appointments for in-person or virtual visits.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
